import { render, staticRenderFns } from "./ProductEditDimension.vue?vue&type=template&id=4f59dcb6&"
import script from "./ProductEditDimension.vue?vue&type=script&lang=js&"
export * from "./ProductEditDimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports